import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.template.html',
})
export class AppComponent {
  protected readonly title = signal('aphpssj');
}
